import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import * as moment from 'moment';
import {Location} from '@angular/common';
import { traductionsKeysEnum } from 'src/assets/i18n/traductionsKeysEnum';

@Component({
  selector: 'app-detail-slot',
  templateUrl: './detail-slot.component.html',
  styleUrls: ['./detail-slot.component.scss'],
})
export class DetailSlotComponent implements OnInit {
  title = 'angulardatatables';
  dtOptions: DataTables.Settings = {};
  subject: any;
  image: any;
  client: any;
  dateFormat: any;
  id: any;
  time: any;


  constructor(
    private route: ActivatedRoute,
    public location: Location) {}
  formatDate(date) {
    return moment(date).format('h:mm');

  }
  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    }
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((res) => {
      this.subject = res;
      this.image = this.subject.params.image;
      this.dateFormat = this.subject.params.StartTime;
      this.id = this.subject.params.Subject;
      this.time = this.subject.params.duree;
    });
  }

  protected readonly traductionsKeysEnum = traductionsKeysEnum;
}
